module.exports = __webpack_public_path__ + "static/media/black-friday-2022.f66a3fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/new-banner/black-friday-2022.png
// module id = 2255
// module chunks = 0